/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchEntitiesBatch} from '../api'

export const useMutationSearchEntitiesBatch = createReactQueryMutationHook('searchEntitiesBatch', searchEntitiesBatch)
